import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import MultiLoadAdapter from "i18next-multiload-backend-adapter";
import * as packageJson from "@louis/translations/package.json";
import { initReactI18next } from "react-i18next";
import LanguageHandler from "./language";

i18n.use(MultiLoadAdapter)
    .use(initReactI18next)
    .init({
        backend: {
            backend: HttpApi,
            backendOption: {
                loadPath: TRANSLATIONS_ROOT_PATH + "/{{lng}}.json",
                allowMultiLoading: true,
                crossDomain: true,
            },
        },
        lng: LanguageHandler.getCurrentLanguage(),
        ns: packageJson.louisTranslations.textDomains,
        fallbackLng: false,
        nsSeparator: false,
        keySeparator: false,
        react: { useSuspense: true },
        // The option below ensures only one request is made, as the current CDN backend serving translations
        // does not support filtering by a group of namespaces.
        //
        // The issue is that the MultiLoadAdapter expects the backend (in our case, the CDN) to support
        // requests based on both language and namespace, e.g., '/{{ns}}/{{lng}}.json'.
        // However, our current setup only returns the entire 'lng.json' file.
        //
        // As a result, the backend loader ends up making multiple redundant requests.
        // A proper configuration example can be found here:
        // https://github.com/i18next/i18next-multiload-backend-adapter/blob/master/examples/simple/app.js
        //
        // If we eventually add support for namespace-based multi-loading,
        // this line can be removed and the `backendOption.loadPath` should be updated to something like:
        // '/{{lng}}/{{ns}}.json'
        maxParallelReads: packageJson.louisTranslations.textDomains.length,
    });

export default i18n;
